<template>
  <div :class="sectionClasses">
    <slot />
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  padding: {
    type: String,
    default: '20px',
    required: false,
  },
});
const { padding } = toRefs(props);
const paddingClass = computed(
  () => paddingClasses[padding.value ?? '20px'] ?? paddingClasses['20px']
);
const sectionClasses = computed(() => ['padding-wrapper h-full', paddingClass.value]);
const paddingClasses: Record<string, string> = {
  '40px': 'lg:p-10 md:p-8 p-6',
  '20px': 'lg:p-5 md:p-15px p-10px',
  '0px': 'lg:p-0',
};
</script>
<style></style>
